export const PAGE_TYPES = {
  COVER: "cover",
  INTRODUCTION: "introduction",
  COMPANY_PROFILE: "company-profile",
  COMPANY_PROFILE_INFO: "company-profile-info",
  SUMMARY: "summary",
  COMMUNAL_DOORS: "communal-doors",
  DOOR_DETAIL: "door-detail",
  DOOR_DETAIL_DOUBLE: "door-detail-double",
  DOOR_PHOTO: "door-photo",
  DOOR_REMEDIAL: "door-remedial",
  ACTION_PLAN: "action-plan",
  ACTION_PLAN_LOADING: "action-plan-loading",
};

export const DOUBLE_DOOR_CONFIG_ID =
  "7c9a1c2e-8f57-4e2f-a1a1-1a01a9d0f102";

export const DEFAULT_PAGE_HEIGHT_PX = 1123;
export const PAGE_MARGIN_PX = 10;
export const CHUNK_PAGE_SIZE = 30;
/** Small payload for Property View Details background preload */
export const PRELOAD_PAGE_SIZE = 15;
